// extracted by mini-css-extract-plugin
export default {"card":"MarketCard_card__cZ9I9","name":"MarketCard_name__cNALM","img":"MarketCard_img__qFzOg","price":"MarketCard_price__x7BIA"};